<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>材料管理</el-breadcrumb-item>
      <el-breadcrumb-item>复合片</el-breadcrumb-item>
    </el-breadcrumb>
    <order-list :category="2"></order-list>
  </div>
</template>

<script>
import OrderList from './index'
export default {
  components: { OrderList },
}
</script>